module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flickerManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("闪屏管理\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newflicker
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flicker"
  }, [_c('el-select', {
    on: {
      "change": _vm.getflickers
    },
    model: {
      value: (_vm.appSource),
      callback: function($$v) {
        _vm.appSource = $$v
      },
      expression: "appSource"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "安卓",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IOS",
      "value": "2"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    on: {
      "change": _vm.getflickers
    },
    model: {
      value: (_vm.flickerStatus),
      callback: function($$v) {
        _vm.flickerStatus = $$v
      },
      expression: "flickerStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "草稿",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待上线",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已上线",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "过期",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.flickers
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "广告说明"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appSource",
      "label": "终端",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applicableCampus",
      "label": "适用学校",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "showtime",
      "label": "展示时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "latestdo",
      "label": "最近操作记录",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editNew(_vm.row.id)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.deleteflicker(_vm.row)
              }
            }
          }, [_vm._v("删除")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 0),
      expression: "totalCount > 0"
    }],
    attrs: {
      "layout": "prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNum,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5077a6d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/flicker/flickerScreen.vue
// module id = 1024
// module chunks = 0